<template>
  <div v-click-outside="outClose">
    <div class="floating-wrapper">
      <input
        class="input-main"
        type="search"
        @click="
          openMenu = !openMenu;
          showItemsCount = false;
        "
        @blur="
          selectedItems.length > 0 && searchTagQuery.length === 0
            ? (showItemsCount = true)
            : (showItemsCount = false)
        "
        @focus="showItemsCount = false"
        :placeholder="'Type'"
        v-model="searchTagQuery"
      />
      <!--:placeholder="'Click Type ' + filterOptions().length"-->
      <span
        @click="showItemsCount = false"
        v-if="showItemsCount"
        class="selsected-count"
      >
        {{ selectedItems.length }} +
      </span>
    </div>
    <div class="root" v-if="showResults || openMenu">
      <input
        type="checkbox"
        class="all-checkbox"
        @click="checkSelectAll"
        :checked="selectAll"
        id="check-all"
      />
      <label class="label-check-all" for="check-all">All </label>
      <input type="checkbox" class="item-checkbox" :value="opt" id="exclude" />
      <label class="item-text" for="exclude">Exclusion</label>
      <div class="dropdown-divider"></div>
      <div class="scroller-div">
        <div v-if="showResults">
          <ul>
            <li v-for="(opt, idx) in result" :key="idx">
              <input
                type="checkbox"
                class="item-checkbox"
                v-model="selectedItems"
                :value="opt"
                :id="opt.id"
              />
              <label class="item-text" :title="opt.title" :for="opt.id">
                {{ opt.title }}</label
              >
              <span class="item-counter"> - {{ getStats(opt.id).count }}</span>
            </li>
          </ul>
        </div>
        <div v-if="openMenu && !showResults">
          <ul>
            <li v-for="(opt, idx) in options" :key="idx">
              <input
                type="checkbox"
                class="item-checkbox"
                v-model="selectedItems"
                :value="opt"
                :id="opt.id"
              />
              <label class="item-text" :for="opt.id"> {{ opt.title }}</label>
              <span class="item-counter"> - {{ getStats(opt.id).count }}</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="tag-form-btns">
        <a
          class="tag-form-cancel-btn"
          href="javascript:void(0)"
          @click.prevent="closeSelect"
          ><span class="fas fa-times"></span
        ></a>

        <div class="loader-bottom">
          <loader v-if="requestClickBusy" :size="'3px'"></loader>
        </div>
        <a
          class="tag-form-ok-btn"
          href="javascript:void(0)"
          @click.prevent="resetSelect"
          ><span class="fas fa-sync"></span
        ></a>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import apiClientCreator from "../../../../helpers/api/request";
import Loader from "../../../../main/misc.main/loader/Loader";

export default {
  name: "MultiSelect.component",
  components: { Loader },
  props: {
    options: {
      type: Array,
      required: true
    },
    resetList: {
      type: Boolean,
      required: false
    },

    initiatedFiltering: {
      type: Boolean,
      required: false,
      default: () => false
    },
    queryObject: {
      type: Object
    }
  },
  directives: {
    ClickOutside
  },
  data() {
    return {
      selectedItems: [],
      infoData: [],
      openMenu: false,
      showResults: false,
      searchTagQuery: "",
      result: [],
      showItemsCount: false,
      selectAll: false,
      typeStats: [],
      requestClickBusy: false
    };
  },
  watch: {
    searchTagQuery: function() {
      this.selectedItems.length > 0 && this.searchTagQuery.length === 0
        ? (this.showItemsCount = true)
        : (this.showItemsCount = false);
      this.result = this.filterList(this.searchTagQuery);
      if (this.result.length > 0) {
        this.showResults = true;
      }
      if (this.searchTagQuery === "") {
        this.showResults = false;
      }
    },
    resetList: function() {
      if (this.resetList === true) {
        this.selectedItems = [];
      }
    },
    selectedItems: function() {
      if (this.selectedItems.length > 0 && this.searchTagQuery.length === 0) {
        this.showItemsCount = true;
      } else {
        this.showItemsCount = false;
      }
    },
    openMenu: function() {
      if (this.openMenu) {
        this.fetchStats();
      }
    },
    initiatedFiltering: function() {
      if (this.initiatedFiltering && this.typeStats.length > 0) {
        this.typeStats = [];
      }
    }
  },

  methods: {
    fetchStats() {
      if (this.typeStats.length === this.options.length) {
        this.typeStats = [];
      }
      if (
        !this.requestClickBusy &&
        this.typeStats.length < this.options.length
      ) {
        this.requestClickBusy = true;
        // const id = this.typeStats.length;
        apiClientCreator(`tasks/stats/ms/type`)
          .get("", { params: this.queryObject })
          .then(res => {
            // res.data.map(item => {
            //  .push(item);
            // });
            this.typeStats = res.data;
            this.requestClickBusy = false;
          })
          .catch(err => {
            this.requestClickBusy = false;
          });
      }
    },
    getStats(i) {
      const stat = this.typeStats.find(item => item.task_type === i);
      if (stat === undefined) {
        return { count: "load..." };
      }
      return stat;
    },

    outClose() {
      if (this.openMenu === true) {
        this.$emit("input", this.selectedItems);
        this.closeSelect();
      }
    },
    checkSelectAll: function() {
      this.selectedItems = [];
      let click;
      if (!this.selectAll) {
        for (click in this.options) {
          this.selectedItems.push(this.options[click]);
        }
      }
      this.selectAll = !this.selectAll;
    },
    closeSelect() {
      this.searchTagQuery = "";
      this.showResults = false;
      this.openMenu = false;
    },
    resetSelect() {
      this.selectedItems = [];
      this.selectAll = false;
      this.typeStats = [];
      this.$emit("input", this.selectedItems);

      this.$emit("reset");
      this.closeSelect();
    },
    filterList(q) {
      function escapeRegExp(s) {
        return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
      }
      const words = q
        .split(/\s+/g)
        .map(s => s.trim())
        .filter(s => !!s);
      const hasTrailingSpace = q.endsWith(" ");
      const searchRegex = new RegExp(
        words
          .map((word, i) => {
            if (i + 1 === words.length && !hasTrailingSpace) {
              return `(?=.*\\b${escapeRegExp(word)})`;
            } else {
              return `(?=.*\\b${escapeRegExp(word)}\\b)`;
            }
          })
          .join("") + ".+",
        "gi"
      );
      return this.options.filter(item => {
        return searchRegex.test(item.title);
      });
    }
  }
};
</script>

<style scoped>
.floating-wrapper {
  position: relative;
}
.selsected-count {
  position: absolute;
  top: 8px;
  left: 10px;
  background: white;
  font-size: 8pt;
  height: 20px;
  width: 80%;
}
.root {
  position: absolute;
  top: 30px;
  left: 0px;
  width: max-content;
  z-index: 10001;
  border: solid 1px #ccc;
  padding: 5px;
  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}
ul {
  list-style: none;
  padding-left: 0;
}

li {
  margin: 5px;
  font-size: 9pt;
  text-align: left;
}

li:hover {
  background: #e0e0e0;
  cursor: pointer;
}
.item-text {
  font-family: "SegoePro-Regular", Arial, sans-serif;
  font-size: 9pt;
}
.item-checkbox {
  margin-right: 5px;
}
.item-counter {
  font-size: 8pt;

  margin-left: 10px;
}
.scroller-div {
  height: auto;
  max-height: 120px;
  overflow-x: hidden;
}
.label-check-all {
  font-family: "SegoePro-Regular", Arial, sans-serif;
  font-size: 9pt;
  cursor: pointer;
  margin-right: 20px;
}
.all-checkbox {
  vertical-align: middle;
  margin-bottom: 5px;
  margin-right: 5px;
  text-align: left;
}
.tag-form-cancel-btn {
  color: red !important;
  float: right;
  margin-right: 5px;
  margin-top: 5px;
}

.tag-form-ok-btn {
  color: green !important;
  float: left;
  margin-left: 5px;
  margin-top: 5px;
}
.input-main {
  width: 95%;
  text-align: end;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  border-radius: 5px;
  border-style: solid;
  border-color: #d7d7d7;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 8pt;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: searchfield-cancel-button;
}
input[type="text"],
textarea {
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  outline: none;
  /*  padding: 3px 0px 3px 3px;
  margin: 5px 1px 3px 0px;*/
  border: 1px solid #dddddd;
}

input[type="search"]:focus,
textarea:focus {
  box-shadow: 0 0 5px rgba(81, 203, 238, 1);
  /* padding: 3px 0px 3px 3px;*/
  border: 1px solid rgba(81, 203, 238, 1);
}
.dropdown-divider {
  height: 1px;
  margin: 9px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}
.loader-bottom {
  position: absolute;
  bottom: -5px;
  left: 50%;
}
</style>
